import { MemberShip } from "@/assets";
import { useSubscription } from "@/contexts/SubscriptionProvider";
import React, { useEffect } from "react";
import "./MembershipCard.scss";
import { formatExpiryDate } from "@/utils/function";
import { useSubscriptionToken } from "@/hooks/useSubscriptionToken";

export const MembershipCard = () => {
  const {
    subscription,
    loading: membershiploading,
    error: membershipError,
  } = useSubscription();

  const { subscriptionUrl } = useSubscriptionToken();

  return (
    <div className="membership-card">
      <div className="membership-header">
        <p className="membership-title">Membership</p>
      </div>

      <hr className="divider" />

      {membershiploading ? null : membershipError ? (
        <p className="membership-error">Something went wrong</p>
      ) : subscription?.isSubscribed ? (
        <div className="member-container">
          <div className="membership-info">
            <MemberShip />
            <div>
              <p className="plan-id">
                {subscription?.subscription?.planId} (
                {subscription?.subscription?.billingCycle})
              </p>
              <p className="expiry">
                expiring{" "}
                {formatExpiryDate(
                  new Date(subscription?.subscription?.endDate ?? "")
                )}
              </p>
            </div>
          </div>
          <a
            href={`https://www.pluritongues.com/membership/${subscriptionUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="manage-btn"
          >
            Manage
          </a>
        </div>
      ) : (
        <div className="membership-upgrade">
          <p className="unlimited">Gain Unlimited Access to Pluritongues</p>
          <p className="pricing">
            Go to
            <a
              href={`https://www.pluritongues.com/pricing/${subscriptionUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              pluritongues.com/pricing
            </a>
          </p>
        </div>
      )}
    </div>
  );
};
